import React from 'react';
import PropTypes from 'prop-types';

import List from '../right-pane/list';
import SenderStatusListItem from './sender-status-list-item';

const SendersList = ( { sendersData, editMode, onSelection, onEdit } ) => {
    return (
        <List
            listLength={sendersData.length}
            editMode={editMode}
            onEdit={onEdit}
            type="sender"
        >
            {
                sendersData.map( sender =>
                    <SenderStatusListItem item={sender} key={sender.id} editMode={editMode} onSelection={onSelection} />
                )
            }
        </List>
    );
};

SendersList.propTypes = {
    editMode: PropTypes.bool,
    onEdit: PropTypes.func,
    onSelection: PropTypes.func,
    sendersData: PropTypes.arrayOf(
        PropTypes.shape( {
            countsByDomain: PropTypes.object,
            id: PropTypes.string,
            name: PropTypes.string,
            url: PropTypes.string,
            verified: PropTypes.bool,
        } )
    ),
};

SendersList.defaultProps = {
    editMode: false,
};

export default SendersList;
